export enum recruiterRoleEnum {
  admin = 'admin',
  regular = 'regular',
}

export enum typeForAPI {
  DELETEREQUESTS = 'deleteRequest',
  ACTIVEACCOUNTS = 'activeAccounts',
}
